module.exports = __webpack_public_path__ + "c41825f652b06a9c55b32831ed90485b.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/logo.png
// module id = 689
// module chunks = 0